import { dataBabyBottleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBabyBottleSolid = /*#__PURE__*/createIcon(dataBabyBottleSolid)
export default IconBabyBottleSolid
